import { jsx, jsxs } from "react/jsx-runtime";
import { Button, H5, Theme, XStack, YStack, useThemeName } from "tamagui";
function ThemeInverseDemo() {
  const themeName = useThemeName();
  const opposite = themeName.includes("dark") ? "light" : "dark";
  return /* @__PURE__ */ jsxs(XStack, { space: true, children: [
    /* @__PURE__ */ jsx(Buttons, { title: "Normal", name: themeName }),
    /* @__PURE__ */ jsx(Theme, { inverse: true, children: /* @__PURE__ */ jsx(
      Buttons,
      {
        title: "Inversed",
        name: themeName.replace(themeName.split("_")[0], opposite)
      }
    ) })
  ] });
}
function Buttons(props) {
  return /* @__PURE__ */ jsxs(
    YStack,
    {
      elevation: "$4",
      backgroundColor: "$background",
      padding: "$4",
      borderRadius: "$4",
      space: "$3",
      children: [
        /* @__PURE__ */ jsx(H5, { children: props.title }),
        /* @__PURE__ */ jsx(Button, { children: props.name }),
        /* @__PURE__ */ jsx(Button, { themeInverse: true, children: "inversed" }),
        /* @__PURE__ */ jsxs(Button, { theme: "alt1", children: [
          props.name,
          "_alt1"
        ] }),
        /* @__PURE__ */ jsx(Theme, { name: "yellow", children: /* @__PURE__ */ jsx(Button, { children: props.name.split("_")[0] + "_yellow" }) })
      ]
    }
  );
}
export {
  ThemeInverseDemo
};
//# sourceMappingURL=ThemeInverseDemo.js.map
